import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { unstable_HistoryRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';
import { store } from './store/store';
import App from './App';
import GlobalStyle from './assets/styled/global.styled';
import SentryProvider from 'providers/SentryProvider/SentryProvider';
import history from 'utils/history';

const persistor = persistStore(store);
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: false,
      staleTime: 30000, // Cache data will be valid for 30 seconds, so no new requests for the same resource will be performed within this time frame
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <SentryProvider>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={history as any}>
            <GlobalStyle />
            <App />
          </Router>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  </SentryProvider>
  // </React.StrictMode>
);
